import { convertDateToISO } from '../../components/Utils/utils';

const useFormatRomaneioPayload = () => {
  const formatPayload = (data) => {
    return {
      oldId: data.oldId || null,
      type: data.entry ? "ENTRADA" : "SAIDA",
      rateType: data.grossWeight ? "BRUTO" : "LIQUIDO",
      entryDate: convertDateToISO(data.entryDate) || null,
      entryHour: data.entryHour || null,
      exitDate: convertDateToISO(data.exitDate) || null,
      exitHour: data.exitHour || null,
      licensePlate: data.licensePlate.licensePlate || data.licensePlate || null,
      numberNF: data.numberNF || '',
      observations: data.observations || null,
      weightNF: data.weightNF || 0,
      balance: data.balance || null,
      tare: data.tare || null,
      harvestId: data.harvestId?.id || null,
      driverId: data.driverId?.id || null,
      lotId: data.lotId?.id || null,
      originPersonId: data.originPersonId?.id || null,
      destinyPersonId: data.destinyPersonId?.id || null,
      farmId: data.farmId?.id || null,
      siloId: data.siloId?.id || null,
      productId: data.productId?.id || null,
      discountId: data.discountId?.id || null,
      ardido: data.ardido || 0,
      ardidoWeight: data.ardidoWeight || 0,
      avariado: data.avariado || 0,
      avariadoWeight: data.avariadoWeight || 0,
      impureza: data.impureza || 0,
      impurezaWeight: data.impurezaWeight || 0,
      umidade: data.umidade || 0,
      umidadeWeight: data.umidadeWeight || 0,
      quebrado: data.quebrado || 0,
      quebradoWeight: data.quebradoWeight || 0,
      verde: data.verde || 0,
      verdeWeight: data.verdeWeight || 0,
      ratePerc: data.ratePerc || 0,
      rateKg: data.rateKg || 0,
      active: typeof data.active !== 'undefined' ? data.active : true,
      totalWeight: data.labelWeightNotDiscount || 0,
      totalDiscounts: data.labelDiscount || 0,
      total: data.labelWeightAndRate || 0,
    };
  };

  return { formatPayload };
};

export default useFormatRomaneioPayload;